import { Lightning, Colors } from '@lightningjs/sdk';

export default class Button extends Lightning.Component {
  static _template() {
    return {
      Border: {},
    };
  }

  _focus() {
    this._Border.patch({
      texture: Lightning.Tools.getRoundRect(553, 70, 15, 3, Colors('#02AC25').get(), false),
    });
  }

  _unfocus() {
    this._Border.patch({
      texture: Lightning.Tools.getRoundRect(553, 70, 15, 3, Colors('#D6D6D6').get(), false),
    });
  }

  _firstEnable() {
    this._Border.patch({
      texture: Lightning.Tools.getRoundRect(553, 70, 15, 3, Colors('#D6D6D6').get(), false),
    });
  }

  _handleHover() {
    this.fireAncestors('$setState', 'ContinueBtn');
    this._focus();
  }

  _handleUnhover() {
    this._unfocus();
  }

  get _Border() {
    return this.tag('Border');
  }
}
